import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MyResumesHeader from '../../../components/MyPage/MyApply/Resumes/MyResumes/MyResumesHeader';
import AllResumeCard from '../../../components/MyPage/MyApply/Resumes/MyResumes/AllResumeCard';
import { ReactComponent as NavigationLeftIcon } from '@repo/common/assets/icons/20px/icon_20px_navigation-left.svg';
import { Toast, useIsMobile, useT } from '@repo/common';

const MyResumes = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const t = useT();
  const [sortBy, setSortBy] = useState('By Date');
  const [standardToastKey, setStandardToastKey] = useState(0);
  const [deleteToastKey, setDeleteToastKey] = useState(0);
  const [standardToastShow, setStandardToastShow] = useState(false);
  const [deleteToastShow, setDeleteToastShow] = useState(false);

  const handleStandardSuccess = () => {
    setStandardToastKey((prev) => prev + 1);
    setStandardToastShow(true);
  };

  const handleDeleteSuccess = () => {
    setDeleteToastKey((prev) => prev + 1);
    setDeleteToastShow(true);
  };

  const handleBackToMenu = () => {
    navigate('/mypage?tab=My%20Apply');
  };

  return (
    <div className='flex flex-col items-center tabletH:p-10 tabletH:pb-[320px] bg-grayscale-gray01 w-full min-h-[1006px] overflow-y-auto'>
      {isMobile && (
        <button
          type='button'
          onClick={handleBackToMenu}
          className='w-full flex items-center justify-start px-4 py-1.5 bg-grayscale-gray01 h-[54px]'
        >
          <div className='flex items-center gap-2 typo-title2 text-text-primary'>
            <NavigationLeftIcon />
            {t('My resumes', '내 이력서')}
          </div>
        </button>
      )}

      <MyResumesHeader
        sortBy={sortBy}
        onSortChange={(value) => setSortBy(value)}
        $isMobile={isMobile}
      />

      <AllResumeCard
        sortBy={sortBy}
        onStandardSuccess={handleStandardSuccess}
        onDeleteSuccess={handleDeleteSuccess}
        $isMobile={isMobile}
      />

      {standardToastShow && (
        <div
          key={standardToastKey}
          className='fixed bottom-6 left-1/2 -translate-x-1/2 z-[1000]'
        >
          <Toast title={t('Standard resume set', '기본 이력서로 설정되었습니다')} customWidth='280px' />
        </div>
      )}

      {deleteToastShow && (
        <div
          key={deleteToastKey}
          className='fixed bottom-6 left-1/2 -translate-x-1/2 z-[1000]'
        >
          <Toast title={t('Resume deleted', '이력서가 삭제되었습니다')} customWidth='240px' />
        </div>
      )}
    </div>
  );
};

export default MyResumes;
